__turbopack_context__.v({
  "backdropContainer": "Modal-module-scss-module__9ug2Ka__backdropContainer",
  "backdropContainerNoOpacity": "Modal-module-scss-module__9ug2Ka__backdropContainerNoOpacity",
  "bgColorFacebook": "Modal-module-scss-module__9ug2Ka__bgColorFacebook",
  "bgColorGoogle": "Modal-module-scss-module__9ug2Ka__bgColorGoogle",
  "bgColorInstagram": "Modal-module-scss-module__9ug2Ka__bgColorInstagram",
  "bgColorLinkedin": "Modal-module-scss-module__9ug2Ka__bgColorLinkedin",
  "bgColorOffice365": "Modal-module-scss-module__9ug2Ka__bgColorOffice365",
  "bgColorTwitter": "Modal-module-scss-module__9ug2Ka__bgColorTwitter",
  "blocksBackgroundColor": "Modal-module-scss-module__9ug2Ka__blocksBackgroundColor",
  "blocksFontColor": "Modal-module-scss-module__9ug2Ka__blocksFontColor",
  "close": "Modal-module-scss-module__9ug2Ka__close",
  "closeAdmin": "Modal-module-scss-module__9ug2Ka__closeAdmin",
  "closeTransparent": "Modal-module-scss-module__9ug2Ka__closeTransparent",
  "exitButton": "Modal-module-scss-module__9ug2Ka__exitButton",
  "fontColorFacebook": "Modal-module-scss-module__9ug2Ka__fontColorFacebook",
  "fontColorGoogle": "Modal-module-scss-module__9ug2Ka__fontColorGoogle",
  "fontColorInstagram": "Modal-module-scss-module__9ug2Ka__fontColorInstagram",
  "fontColorLinkedin": "Modal-module-scss-module__9ug2Ka__fontColorLinkedin",
  "fontColorOffice365": "Modal-module-scss-module__9ug2Ka__fontColorOffice365",
  "fontColorTwitter": "Modal-module-scss-module__9ug2Ka__fontColorTwitter",
  "modal": "Modal-module-scss-module__9ug2Ka__modal",
  "modalBackdrop": "Modal-module-scss-module__9ug2Ka__modalBackdrop",
  "modalBody": "Modal-module-scss-module__9ug2Ka__modalBody",
  "modalContainer": "Modal-module-scss-module__9ug2Ka__modalContainer",
  "modalContainerTransparent": "Modal-module-scss-module__9ug2Ka__modalContainerTransparent",
  "modalContent": "Modal-module-scss-module__9ug2Ka__modalContent",
  "modalContentTransparent": "Modal-module-scss-module__9ug2Ka__modalContentTransparent",
  "modalDialog": "Modal-module-scss-module__9ug2Ka__modalDialog",
  "modalDialogTransparent": "Modal-module-scss-module__9ug2Ka__modalDialogTransparent",
  "modalFooter": "Modal-module-scss-module__9ug2Ka__modalFooter",
  "modalHeader": "Modal-module-scss-module__9ug2Ka__modalHeader",
  "modalLg": "Modal-module-scss-module__9ug2Ka__modalLg",
  "modalOpen": "Modal-module-scss-module__9ug2Ka__modalOpen",
  "modalSchoolblocks": "Modal-module-scss-module__9ug2Ka__modalSchoolblocks",
  "modalScrollbarMeasure": "Modal-module-scss-module__9ug2Ka__modalScrollbarMeasure",
  "modalSm": "Modal-module-scss-module__9ug2Ka__modalSm",
  "modalTitle": "Modal-module-scss-module__9ug2Ka__modalTitle",
  "modalTransparent": "Modal-module-scss-module__9ug2Ka__modalTransparent",
  "modalXl": "Modal-module-scss-module__9ug2Ka__modalXl",
  "secondaryNavBackgroundColor": "Modal-module-scss-module__9ug2Ka__secondaryNavBackgroundColor",
  "themeBackgroundColor": "Modal-module-scss-module__9ug2Ka__themeBackgroundColor",
  "themeFontColor": "Modal-module-scss-module__9ug2Ka__themeFontColor",
  "transitionAppear": "Modal-module-scss-module__9ug2Ka__transitionAppear",
  "transitionAppearActive": "Modal-module-scss-module__9ug2Ka__transitionAppearActive",
  "transitionAppearDone": "Modal-module-scss-module__9ug2Ka__transitionAppearDone",
  "transitionEnter": "Modal-module-scss-module__9ug2Ka__transitionEnter",
  "transitionEnterActive": "Modal-module-scss-module__9ug2Ka__transitionEnterActive",
  "transitionEnterDone": "Modal-module-scss-module__9ug2Ka__transitionEnterDone",
  "transitionExit": "Modal-module-scss-module__9ug2Ka__transitionExit",
  "transitionExitActive": "Modal-module-scss-module__9ug2Ka__transitionExitActive",
  "transitionExitDone": "Modal-module-scss-module__9ug2Ka__transitionExitDone",
});
